import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { profileData } from '../data/mock';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    alert('Terima kasih! Pesan Anda telah diterima. Tim kami akan segera menghubungi Anda.');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="kontak" className="py-20 px-4" style={{ background: 'var(--bg-section)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Hubungi Kami</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Ada pertanyaan atau ingin konsultasi? Kami siap membantu Anda
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-8">
          {/* Contact Info */}
          <div className="md:col-span-2 space-y-6">
            <div className="voice-card accent-purple">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ background: 'rgba(152, 125, 156, 0.3)' }}>
                  <MapPin size={24} style={{ color: 'var(--accent-purple-400)' }} />
                </div>
                <div>
                  <h3 className="heading-3 mb-2">Alamat Kantor</h3>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    {profileData.contact.address}
                  </p>
                </div>
              </div>
            </div>

            <div className="voice-card accent-blue">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ background: 'rgba(118, 133, 151, 0.3)' }}>
                  <Mail size={24} style={{ color: 'var(--accent-blue-400)' }} />
                </div>
                <div>
                  <h3 className="heading-3 mb-2">Email</h3>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    {profileData.contact.email}
                  </p>
                </div>
              </div>
            </div>

            <div className="voice-card accent-orange">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ background: 'rgba(188, 161, 130, 0.3)' }}>
                  <Phone size={24} style={{ color: 'var(--accent-orange-400)' }} />
                </div>
                <div>
                  <h3 className="heading-3 mb-2">Telepon & WhatsApp</h3>
                  <p className="body-small mb-1" style={{ color: 'var(--text-secondary)' }}>
                    {profileData.contact.phone}
                  </p>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    WA: {profileData.contact.whatsapp}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:col-span-3">
            <form onSubmit={handleSubmit} className="voice-card">
              <h3 className="heading-3 mb-6">Kirim Pesan</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="body-small block mb-2" style={{ color: 'var(--text-primary)' }}>
                    Nama Lengkap *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Masukkan nama lengkap Anda"
                    className="w-full px-4 py-3 rounded-lg border body-medium"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-card)',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="body-small block mb-2" style={{ color: 'var(--text-primary)' }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="email@example.com"
                      className="w-full px-4 py-3 rounded-lg border body-medium"
                      style={{ 
                        borderColor: 'var(--border-input)',
                        background: 'var(--bg-card)',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                      onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                    />
                  </div>

                  <div>
                    <label className="body-small block mb-2" style={{ color: 'var(--text-primary)' }}>
                      Nomor Telepon
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+62 812 3456 7890"
                      className="w-full px-4 py-3 rounded-lg border body-medium"
                      style={{ 
                        borderColor: 'var(--border-input)',
                        background: 'var(--bg-card)',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                      onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                    />
                  </div>
                </div>

                <div>
                  <label className="body-small block mb-2" style={{ color: 'var(--text-primary)' }}>
                    Subjek *
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Topik konsultasi atau pertanyaan"
                    className="w-full px-4 py-3 rounded-lg border body-medium"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-card)',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                  />
                </div>

                <div>
                  <label className="body-small block mb-2" style={{ color: 'var(--text-primary)' }}>
                    Pesan *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Jelaskan kebutuhan atau pertanyaan Anda..."
                    className="w-full px-4 py-3 rounded-lg border body-medium resize-none"
                    style={{ 
                      borderColor: 'var(--border-input)',
                      background: 'var(--bg-card)',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                  />
                </div>

                <button type="submit" className="btn-primary w-full flex items-center justify-center gap-2">
                  <Send size={16} />
                  <span>Kirim Pesan</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
